import React from "react";
import { Field } from "redux-form";

import { customInput } from "../../../../common/custom-input";

import styles from "../../JobStyle.module.css";

const OurCompanySection = ({ loading }) => {
  return (
    <div className="my-2">
      <div className="container-fluid px-0">
        {/* Row 1: Company Name, ABN, Address */}
        <div className="row mb-2">
          <div className="col-12 col-md-4 col-lg-4 col-xl-4">
            <div className={styles.Label}>Company Name</div>
            <Field name="company_name" className={styles.TextField} component={customInput} disabled={loading} />
          </div>
          <div className="col-12 col-md-4 col-lg-4 col-xl-4">
            <div className={styles.Label}>ABN</div>
            <Field name="company_abn" className={styles.TextField} component={customInput} disabled={loading} />
          </div>
          <div className="col-12 col-md-4 col-lg-4 col-xl-4">
            <div className={styles.Label}>Address</div>
            <Field name="company_address" className={styles.TextField} component={customInput} disabled={loading} />
          </div>
        </div>
        {/* Row 2: Company Email, Company Phone, Company Website */}
        <div className="row mb-2">
          <div className="col-12 col-md-4 col-lg-4 col-xl-4">
            <div className={styles.Label}>Company Email</div>
            <Field name="company_email" className={styles.TextField} component={customInput} disabled={loading} />
          </div>
          <div className="col-12 col-md-4 col-lg-4 col-xl-4">
            <div className={styles.Label}>Company Phone</div>
            <Field name="company_phone" className={styles.TextField} component={customInput} disabled={loading} />
          </div>
          <div className="col-12 col-md-4 col-lg-4 col-xl-4">
            <div className={styles.Label}>Company Website</div>
            <Field name="company_website" className={styles.TextField} component={customInput} disabled={loading} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurCompanySection;
